module.exports = "/_next/static/images/98af851eec540b52eb1dae6fd54c49fd-complexity@lg-1x.jpg";